import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import CurrencyInput from "react-currency-input-field";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toAbsoluteUrl,
} from "../../../../../_metronic/_helpers";
import { Input, Pagination } from "../../../../../_metronic/_partials/controls";
import {
  fetchProjectManage,
  findIncomeItems,
  updateProjectIncome,
} from "../../_redux/project/projectAction";
import SVG from "react-inlinesvg";
import { Field, Formik } from "formik";
import { DateRangePicker } from "react-dates";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { getProgramAll } from "../../../MasterData/_redux/program/programCrud";

export default function ModalEditIncome({ show, onHide, id }) {
  const dispatch = useDispatch();

  const [incomeData, setIncomeData] = useState([]);
  const [deletedData, setDeletedData] = useState([]);

  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 25,
    filter: {
      donor_name: "",
      donor_id: "",
      donation_hid: "",
      start_date: "",
      end_date: "",
      program_uuid: "",
      amountLte: "",
      amountGte: "",
      balanceLte: "",
      balanceGte: "",
    },
  });

  //   * FETCH DATA
  useEffect(() => {
    if (show) {
      dispatch(findIncomeItems(id, queryParams));
    }
  }, [queryParams, dispatch, show]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.project }),
    shallowEqual
  );

  const { listLoading, totalCount } = currentState;

  useEffect(() => {
    // setIncomeData(incomeItems);
    setDeletedData([]);
  }, [show]);

  useEffect(() => {
    if (currentState.incomeItems instanceof Array)
      setIncomeData(currentState.incomeItems);
  }, [currentState]);

  //   * TABLE
  const sizePerPageList = [
    { text: "25", value: 25 },
    { text: "50", value: 50 },
    { text: "100", value: 100 },
    { text: "200", value: 200 },
    { text: "500", value: 500 },
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  const columns = [
    {
      dataField: "donation_item.donation.donation_hid",
      text: "Id Donation",
    },
    {
      dataField: "donation_item.type",
      text: "Jenis Dana",
    },
    {
      dataField: "donation_item.program.name",
      text: "Program",
    },
    {
      dataField: "donation_item.amount",
      text: "Nominal Item Donasi",
      classes: "text-right",
      headerClasses: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
    },
    {
      dataField: "donation_item.balance",
      text: "Balance Item Donasi",
      classes: "text-right",
      headerClasses: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
    },
    {
      dataField: "amount",
      text: "Nominal Projek",
      classes: "text-right",
      headerClasses: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
    },
    {
      dataField: "amount",
      text: "Edit Nominal Projek",
      headerClasses: "text-right",
      formatter: (cell, row, index) => {
        return (
          <>
            <CurrencyInput
              name="amount"
              placeholder="Masukkan Nominal"
              intlConfig={{
                locale: "id-ID",
                currency: "IDR"
              }}
              disabled={!row.checked}
              autoFocus={true}
              className="form-control text-right"
              defaultValue={cell}
              decimalsLimit={2}
              label="Nominal"
              onValueChange={(value, name) => {
                setIncomeData(prevState => {
                  const clonedData = JSON.parse(JSON.stringify(prevState));
                  clonedData[index][name] = value;
                  return clonedData;
                });
              }}
            />
          </>
        );
      },
    },
    {
      formatter: (cell, row) => {
        return (
          <>
            <OverlayTrigger
              overlay={
                <Tooltip id="products-delete-tooltip">Hapus Penerimaan</Tooltip>
              }
            >
              <a
                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                onClick={() => {
                  setIncomeData((prevState) => {
                    const copyArr = [...prevState];
                    const newData = copyArr.filter(
                      (item) => item.uuid !== row.uuid
                    );
                    return newData;
                  });
                  setDeletedData((prevState) => {
                    const newData = [...prevState];
                    newData.push(row);
                    return newData;
                  });
                }}
              >
                <span className="svg-icon svg-icon-md svg-icon-danger">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                  />
                </span>
              </a>
            </OverlayTrigger>
          </>
        );
      },
    },
  ];

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect, index) => {
      if (isSelect) {
        setIncomeData((prevState) => {
          const clonedData = JSON.parse(JSON.stringify(prevState));
          //   console.log(clonedData[index][name]);
          clonedData[index]["checked"] = true;
          return clonedData;
        });
      } else {
        setIncomeData((prevState) => {
          const clonedData = JSON.parse(JSON.stringify(prevState));
          //   console.log(clonedData[index][name]);
          clonedData[index]["checked"] = false;
          return clonedData;
        });
      }
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        setIncomeData(
          rows.map((item) => ({
            ...item,
            checked: true,
          }))
        );
      } else {
        setIncomeData(
          rows.map(item => ({
            ...item,
            checked: false
          }))
        );
      }
    },
  };

  const saveData = () => {
    const editedData = incomeData.filter((item) => {
      if (item.checked) return item;
    });

    const data = {
      uuid: id,
      income_update: editedData,
      income_remove: deletedData,
    };
    dispatch(updateProjectIncome(data)).then(() => {
      dispatch(fetchProjectManage(id));
      onHide();
    });
  };

  // * FILTER
  const [tanggal, setTanggal] = useState({
    start_date: null,
    end_date: null,
  });
  const [onFocused, setOnFocused] = useState(null);
  const [options, setOptions] = useState({
    program: [],
  });

  useEffect(() => {
    getProgramAll().then((res) =>
      setOptions((prevState) => ({
        ...prevState,
        program: res.data.data,
      }))
    );
  }, []);

  return (
    <>
      <Modal size="xl" show={show} onHide={onHide}>
        <Modal.Header>
          <h4>Edit Penerimaan</h4>
        </Modal.Header>
        <Formik
          enableReinitialize
          initialValues={{}}
          onSubmit={(values) =>
            setQueryParams((prevState) => ({
              ...prevState,
              filter: {
                ...prevState.filter,
                ...values,
              },
            }))
          }
        >
          {({ handleSubmit, setFieldValue, values, resetForm }) => (
            <>
              <Modal.Body>
                <div className="form-group row">
                  <div className="col">
                    <DateRangePicker
                      small={true}
                      startDate={tanggal.start_date}
                      endDate={tanggal.end_date}
                      onDatesChange={({ startDate, endDate }) => {
                        setTanggal({
                          start_date: startDate,
                          end_date: endDate,
                        });
                        setFieldValue("start_date", startDate);
                        setFieldValue("end_date", endDate);
                      }}
                      focusedInput={onFocused}
                      onFocusChange={(focusedInput) =>
                        setOnFocused(focusedInput)
                      }
                      numberOfMonths={1}
                      isOutsideRange={() => false}
                      showClearDates={true}
                      startDateId="start_date"
                      endDateId="end_date"
                      hideKeyboardShortcutsPanel={true}
                    />
                    <small className="form-text text-muted">
                      <b>Cari</b> Tanggal
                    </small>
                  </div>
                  <div className="col">
                    <input
                      name="amountGte"
                      type="number"
                      className="form-control"
                      placeholder="Jumlah Lebih dari"
                      value={values.amountGte}
                      onChange={(e) =>
                        setFieldValue(e.target.name, e.target.value)
                      }
                    />
                    <small className="form-text text-muted">
                      <b>Cari</b> Jumlah lebih dari
                    </small>
                  </div>
                  <div className="col">
                    <input
                      name="amountLte"
                      type="number"
                      className="form-control"
                      placeholder="Jumlah kurang dari"
                      value={values.amountLte}
                      onChange={(e) =>
                        setFieldValue(e.target.name, e.target.value)
                      }
                    />
                    <small className="form-text text-muted">
                      <b>Cari</b> Jumlah kurang dari
                    </small>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col">
                    <input
                      name="balanceGte"
                      type="number"
                      className="form-control"
                      placeholder="Jumlah Lebih dari"
                      value={values.balanceGte}
                      onChange={(e) =>
                        setFieldValue(e.target.name, e.target.value)
                      }
                    />
                    <small className="form-text text-muted">
                      <b>Cari</b> Sisa saldo lebih dari
                    </small>
                  </div>
                  <div className="col">
                    <input
                      name="balanceLte"
                      type="number"
                      className="form-control"
                      placeholder="Jumlah kurang dari"
                      value={values.balanceLte}
                      onChange={(e) =>
                        setFieldValue(e.target.name, e.target.value)
                      }
                    />
                    <small className="form-text text-muted">
                      <b>Cari</b> Sisa saldo kurang dari
                    </small>
                  </div>
                  <div className="col">
                    <Autocomplete
                      name="program_uuid"
                      options={options.program}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, value) => {
                        if (value) {
                          setFieldValue("program_uuid", value.uuid);
                        } else {
                          setFieldValue("program_uuid", "");
                        }
                      }}
                      value={
                        options.program.length > 0 &&
                        options.program.find(
                          (option) => option.uuid === values.program_uuid
                        )
                      }
                      loading={options.program.length === 0 ? true : false}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Cari Program"
                          variant="outlined"
                          disableClearable
                          size="small"
                        />
                      )}
                    />
                    <small className="form-text text-muted">
                      <b>Cari</b> Program
                    </small>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col">
                    <input
                      name="donor_name"
                      className="form-control"
                      placeholder="Nama Donatur"
                      value={values.donor_name}
                      onChange={(e) =>
                        setFieldValue(e.target.name, e.target.value)
                      }
                    />
                    <small className="form-text text-muted">
                      <b>Cari</b> Berdasarkan Nama
                    </small>
                  </div>
                  <div className="col">
                    <input
                      name="donor_id"
                      className="form-control"
                      placeholder="Id Donatur"
                      value={values.donor_id}
                      onChange={(e) =>
                        setFieldValue(e.target.name, e.target.value)
                      }
                    />
                    <small className="form-text text-muted">
                      <b>Cari</b> Id Donatur
                    </small>
                  </div>
                  <div className="col">
                    <input
                      name="donation_hid"
                      className="form-control"
                      placeholder="Donation HID"
                      value={values.donation_hid}
                      onChange={(e) =>
                        setFieldValue(e.target.name, e.target.value)
                      }
                    />
                    <small className="form-text text-muted">
                      <b>Cari</b> Donation HID
                    </small>
                  </div>
                </div>
                <div className="mt-4">
                  <button
                    className="btn btn-warning float-right mr-4 ml-4"
                    onClick={handleSubmit}
                  >
                    Terapkan
                  </button>
                  {/* <button
                    className="btn btn-danger float-right mr-4 ml-4"
                    onClick={() => resetForm()}
                  >
                    Hapus Filter
                  </button> */}
                </div>
              </Modal.Body>
            </>
          )}
        </Formik>
        <Modal.Body>
          <PaginationProvider pagination={paginationFactory(paginationOptions)}>
            {({ paginationProps, paginationTableProps }) => {
              return (
                <Pagination
                  isLoading={listLoading}
                  paginationProps={paginationProps}
                >
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    bordered={false}
                    remote
                    keyField="uuid"
                    data={incomeData}
                    columns={columns}
                    onTableChange={getHandlerTableChange(setQueryParams)}
                    //   ! NANTI DULU
                    selectRow={selectRow}
                    {...paginationTableProps}
                  >
                    <PleaseWaitMessage entities={incomeData} />
                    <NoRecordsFoundMessage entities={incomeData} />
                  </BootstrapTable>
                </Pagination>
              );
            }}
          </PaginationProvider>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={saveData}>
            Simpan
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
